export default "__VITE_ASSET__Bz$0nFEg__"